import { useQuery } from '@tanstack/react-query';
import { CreateSplitPaymentsGroupPayload } from '../../types/payments';
import { createSplitPaymentsGroup } from '../../services/payments';
import useUser from '../global/useUser';

type Args = Omit<CreateSplitPaymentsGroupPayload, 'businessId'>;
type Options = {
  onSuccess?: (
    result: Awaited<ReturnType<typeof createSplitPaymentsGroup>>,
  ) => void;
  isEnabled?: boolean;
};

function useCreateSplitPaymentsGroup(
  { customerId, appointment, discountId, order }: Args,
  { onSuccess, isEnabled = true }: Options = {},
) {
  const { user } = useUser();
  const businessId = user?.business?.id;

  return useQuery({
    queryKey: [
      'create-split-payments-group',
      customerId,
      appointment,
      discountId,
      order,
      businessId,
    ],
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async () => {
      const result = await createSplitPaymentsGroup({
        customerId,
        appointment: appointment || undefined,
        order: order || undefined,
        discountId,
        businessId: businessId!,
      });
      onSuccess?.(result);
      return result;
    },
    enabled:
      isEnabled &&
      !!customerId &&
      (!!appointment?.appointmentId || !!order?.orderItems?.length),
  });
}

export default useCreateSplitPaymentsGroup;
